import LoadUtils from "./LoadUtils.js";
import defaultOptions from "../config/config.js";
import MatomoUtils from "./MatomoUtils.js";
import EventListener from "./EventListener.js";

// 埋点管理类
let TibiMatomo = {};

// 默认参数配置
TibiMatomo.options = defaultOptions;

// keys 自定义keys
TibiMatomo.matomoKeys = {
    matomoScriptId: "tibi-matomo-script-Id",
    host:  "host",
    siteId: "siteId",
}

/**
 * 埋点类初始化
 */
TibiMatomo.init = function (setupOpts) {
    const options = Object.assign({}, defaultOptions, setupOpts);
    TibiMatomo.options = options;
    if(TibiMatomo.options.open){
        const trackerScript = TibiMatomo.options.trackerScriptUrl || `${TibiMatomo.options.host}/${TibiMatomo.options.trackerFileName}.js`;
        MatomoUtils.configMatomo(TibiMatomo.options);
        LoadUtils.loadScript(trackerScript).then(res => {
            console.log('引入js完成----',trackerScript);
            EventListener.addAllEventsMonitor();
        });
    }

};
/**
 * 埋点自动监听初始化
 */
TibiMatomo.autoMonitorInit = function () {
    const scriptEle =   document.getElementById(TibiMatomo.matomoKeys.matomoScriptId);
    if(scriptEle){
         const host = scriptEle.getAttribute(TibiMatomo.matomoKeys.host);
         const siteId = scriptEle.getAttribute(TibiMatomo.matomoKeys.siteId);
         if(!host || !siteId){
             console.warn('host  和  siteId 必须引入');
             return false;
         }
         const setOptions = {
             host: host,
             siteId: siteId
         };
         TibiMatomo.init(setOptions);
    }
};
/**
 * 手动发送事件
 */
TibiMatomo.sendTrackEvent = function (category, action, name, value) {
   MatomoUtils.sendEndPointEvent(category, action, name, value)
};
/**
 * 发送用户id
 */
TibiMatomo.sendUserId = function (userId) {
    MatomoUtils.sendUserId(userId)
};

/**
 * 发送自定义变量
 */
TibiMatomo.sendCustomVariable = function (index, name, value) {
  MatomoUtils.sendCustomVariable(index, name, value);
};

export default  TibiMatomo;